import 'dayjs/locale/es'
import 'dayjs/locale/en'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from '../../utils/helpers/intl/locales/en.json'
import es from '../../utils/helpers/intl/locales/es.json'

const i18Instance = i18n.use(initReactI18next)

const getBaseLanguage = () => {
    return 'es'
}

i18Instance.init({
    resources: {
        en: {
            BlurEffect: en,
        },
        es: {
            BlurEffect: es,
        },
    },
    ns: ['BlurEffect'],
    defaultNS: 'BlurEffect',
    interpolation: {
        escapeValue: false,
    },
    lng: getBaseLanguage(),
    fallbackLng: 'en',
})

export default i18Instance
